const DashboardColorMode = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark'
})
export default DashboardColorMode
export type DashboardColorModeStrings = typeof DashboardColorMode[keyof typeof DashboardColorMode]
// RESERVE BELOW
